import { render, staticRenderFns } from "./CDNSwitch.vue?vue&type=template&id=49e8cc41&scoped=true&"
import script from "./CDNSwitch.vue?vue&type=script&lang=js&"
export * from "./CDNSwitch.vue?vue&type=script&lang=js&"
import style0 from "./CDNSwitch.vue?vue&type=style&index=0&id=49e8cc41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e8cc41",
  null
  
)

export default component.exports